module.exports = global["BVI18n"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./index.js");